import { EventComponent, PlannerEcsSystem } from '../../..';
import SelectedLegComponent from '../../components/SelectedLegComponent';
/**
 * This system sets the default leg by adding a 'SelectedLegComponent' to
 * the scene.
 *
 */
export class DefaultLegsSystem extends PlannerEcsSystem {
    constructor(coreApi, defaultLegProductRef) {
        super(coreApi, 'DefaultLegsSystem', EventComponent.id);
        this.DEFAULT_LEG_PRODUCT_REF = defaultLegProductRef;
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            newComponent.event === 'reset') {
            this.setLeg();
        }
    }
    onRemove() { }
    setLeg() {
        const scene = this.coreApi.entities.getScene();
        scene && scene.addComponent(new SelectedLegComponent(this.DEFAULT_LEG_PRODUCT_REF));
    }
}
//# sourceMappingURL=DefaultLegsSystem.js.map